import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { FormHelperText, FormControlLabel, Box } from '@mui/material';
import { ReactElement } from 'react';

type CheckboxComponentProps = {
  label: string;
  value: unknown;
  onChange: CheckboxProps['onChange'];
  disabled?: boolean;
  checked?: boolean;
  indeterminate?: boolean;
  helperText?: string;
};

const CheckboxComponent = ({
  label,
  value,
  onChange,
  disabled,
  checked,
  helperText,
  indeterminate,
}: CheckboxComponentProps): ReactElement => (
  <Box>
    <FormControlLabel
      label={label}
      control={<Checkbox value={value} checked={checked} indeterminate={indeterminate} onChange={onChange} disabled={!!disabled} />}
    />
    {helperText && <FormHelperText sx={{ marginLeft: '5%', marginTop: '-.5rem' }}>{helperText}</FormHelperText>}
  </Box>
);

export default CheckboxComponent;
